import { Address, YesNoAnswer } from 'scenes/common/types';
import { Driver } from 'scenes/motor/flows/addDriver/types';
import {
  MotorCoverType,
  MotorInsuranceType,
} from 'scenes/motor/flows/coverOptions/types';

export enum MotorQuoteSubSection {
  RecentInsurer = 'Recent insurer',
  AdditionalDrivers = 'Additional drivers',
  OvernightParkingAddress = 'Overnight parking address',
  VehicleDetails = 'Vehicle details',
  VehicleManualSelect = 'Vehicle manual select',
  IsUsedForBusiness = 'Used for business',
  BusinessType = 'Business type',
  VehicleFinance = 'Vehicle finance',
  FinanceType = 'Finance type',
  CoverForDriversUnder25 = 'Cover for drivers under 25',
  PolicyStartDate = 'Policy start date',
  FlybuysNumber = 'Flybuys number',
  ClaimsMade = 'Number of claims',
  PayableClaims = 'Number of claims with excess',
  GenderAndDateOfBirth = 'Gender and date of birth',
  YearsDriving = 'Years of experience',
}

export enum CoverTypeQueryParam {
  COMP = 'COMP',
  TPPD = 'TPPD',
  TPFT = 'TPFT',
}

export type VehicleFromSearch = {
  bodyType: string;
  year: string;
  make: string;
  family: string;
  variant: string;
  driveType: string;
  engine: {
    description: string;
    capacity: { value: string; unit?: string };
    cylinders: string;
  };
  transmissionType: string;
  plateNumber: string;
  code: string;
  nvic: string;
  series: string;
  model: string;
  popular: boolean;
};

export enum Finance {
  Unspecified = '',
  NoFinance = 'No finance',
  SecuredLoan = 'Secured loan',
  UnsecuredLoan = 'Unsecured loan',
  Lease = 'Lease',
  HirePurchaseArrangement = 'Hire purchase arrangement',
}

export type VehicleManuallyEntered = Omit<VehicleFromSearch, 'plateNumber'>;

export enum VehicleManualQuoteDetailsField {
  VehicleMake = 'vehicleMake',
  VehicleModel = 'vehicleModel',
  VehicleManufactureYear = 'vehicleManufactureYear',
  VehicleType = 'vehicleType',
  VehicleEngineType = 'vehicleEngineType',
}

export enum VehicleSearchType {
  ManualEntry = 'manual',
  RegoLookup = 'search-response',
  Unspecified = '',
}

export type DefaultCoverType = {
  preselectedInsuranceType: MotorInsuranceType;
  preselectedCoverType: MotorCoverType;
};

export type VehicleManualSelectFormValues = Record<
  VehicleManualQuoteDetailsField,
  string
>;

export interface MotorQuoteData extends Driver {
  preselectedCoverType: MotorCoverType;
  preselectedInsuranceType: MotorInsuranceType;
  colesCampaignCode: string;
  prefilledCampaignId: string;
  prefilledPromoCode: string;
  overnightParkingAddress: Address;
  policyStartDate: string;
  recentInsurer: string;
  coverLevel: string;
  isUsedForBusiness: YesNoAnswer;
  businessType: string;
  isSmallBusiness: YesNoAnswer;
  finance: Finance;
  vehicleFinancier: string;
  additionalDrivers: Driver[];
  licencePlate: string;
  vehicleFromSearch: VehicleFromSearch;
  hasFlybuys: YesNoAnswer;
  flybuysNumber: string;
  vehicleSearchType: VehicleSearchType;
  vehicleManuallyEntered: VehicleManuallyEntered;
  promoCode: string;
  vehicleManualSelectFields: Record<VehicleManualQuoteDetailsField, string>;
  coverForDriversUnder25: YesNoAnswer;
  addDriver: YesNoAnswer;
  driverIndex?: number;
}
